import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/auto-loan',
  component: () => import('../../routes/AutoLoan.svelte'),
  card: {
    id: 'auto-loan',
    title: 'Auto Loan',
    description: 'Estimate monthly payments and total interest for your dream car purchase.',
    icon: 'directions_car',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/auto-loan',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Auto Loan Calculator – Car Payment & Auto Loan Rates Calculator',
    description: 'Free auto loan calculator for car payments. Calculate monthly auto payments, compare auto loan rates, view amortization schedules, and explore auto refinance options. Includes used car loan calculator with early payoff calculations.',
  },
};

export default meta;
